export default "__VITE_ASSET__CnoTkwdh__"